import { z } from "zod"

export const TABS = [
  "overview",
  "tasks",
  "phases",
  "aircraft",
  "revisions",
  "activity",
] as const

export const tabSchema = z.enum(TABS)

export type Tab = z.infer<typeof tabSchema>

export function tabLabel(tab: Tab): string {
  switch (tab) {
    case "overview":
      return "Overview"
    case "tasks":
      return "Tasks"
    case "phases":
      return "Phases"
    case "aircraft":
      return "Aircraft"
    case "revisions":
      return "Revisions"
    case "activity":
      return "Activity"
  }
}
